import React from 'react';
import ExperienceReview from './common/experience-review';

const AudioReview: React.FunctionComponent = (): JSX.Element => {
  return <ExperienceReview experienceType="audio" />;
};

export default AudioReview;
